(function () {
  'use strict';

  var WRAPPER = '[data-cart-newsletter]';
  var SUCCESS_PARAMS = ['customer_posted=true', 'contact_posted=true'];

  function checkIcon() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function showMessage(wrapper, success) {
    var node = wrapper.querySelector('[data-cart-newsletter-message]');
    var message = wrapper.getAttribute(success ? 'data-success' : 'data-error');
    wrapper.classList.remove('has-success', 'has-error');
    wrapper.classList.add(success ? 'has-success' : 'has-error');
    if (node) {
      node.innerHTML = (success ? checkIcon() : '') + '<span>' + message + '</span>';
      node.focus();
    }
  }

  function init(wrapper) {
    if (wrapper.dataset.cartNewsletterBound) return;
    wrapper.dataset.cartNewsletterBound = '1';

    var form = wrapper.querySelector('[data-cart-newsletter-form]');
    var frame = wrapper.querySelector('iframe');
    if (!form || !frame) return;

    var pending = false;

    // The native submit lets Shopify's reCAPTCHA run and posts into the hidden
    // iframe, so the page never reloads. Invalid emails are blocked by the
    // browser before the submit event fires.
    form.addEventListener('submit', function () {
      pending = true;
      wrapper.classList.remove('has-success', 'has-error');
      wrapper.setAttribute('data-loading', '');
    });

    frame.addEventListener('load', function () {
      if (!pending) return; // ignore the initial blank load
      pending = false;
      wrapper.removeAttribute('data-loading');

      var success = true;
      try {
        var href = frame.contentWindow.location.href || '';
        success = SUCCESS_PARAMS.some(function (param) {
          return href.indexOf(param) !== -1;
        });
      } catch (error) {
        // Cross-origin (e.g. a captcha challenge page) — assume success.
        success = true;
      }

      showMessage(wrapper, success);
    });
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(WRAPPER).forEach(init);
  }

  boot(document);
  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  // The cart drawer re-renders its markup via AJAX, so re-bind new instances.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(WRAPPER)) init(node);
          if (node.querySelectorAll) boot(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
